import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private inj: Injector, private router: Router) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.retrieveToken();
    if (token) {
      request = request.clone({
        setHeaders: {
           'Rfa-Token': token
        }
      });
    }
    return next.handle(request).map((event: HttpEvent<any>) => {
        return event;
      }).catch((err: any, caught) => {
      if (err.status === 403) {
        alert(`Access not permitted to ${err.url}`);
      } else {
        if (typeof(err.error.msg) !== 'undefined') {
          alert(`${err.error.msg}`);
        } else {
          alert(`${err.message}`);
        }
      }
      return Observable.throw(err)
    });
  }

  private retrieveToken(): string {
    let token = null;
    if (typeof(localStorage) !== 'undefined') {
      token = localStorage.getItem('token');
    } else {
      token = this.getCookieValue('token');
    }
    return token;
  }

  private getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}
}



// WEBPACK FOOTER //
// ./src/app/providers/token.interceptor.ts